import React from "react";
import { Helmet } from "react-helmet";
import favicon from "../../assets/images/favicon.ico";
import Navbar from "../navigation/Navbar";
import "../../assets/styles/layout.scss";
import { Link } from "gatsby";

const Layout = ({ children }) => (
  <div>
    <Helmet bodyAttributes={{ class: "has-navbar-fixed-top" }}>
      <meta charSet="utf-8" />
      <meta name="description" content="Maplestory M guides and resources" />
      <meta
        name="keywords"
        content="maplestorym, maplestory m, msm, guides, tutorials, msm help, maplestorym resources"
      />
      <title>Maplestory M Resources</title>
      <link rel="canonical" href="https://maplemresources.com" />
      <link rel="icon" href={favicon} />
    </Helmet>
    <Navbar />
    <main>{children}</main>
    <footer className="legalFooter">
      <div>
        <Link to="/tos">Terms of Service</Link>
        <div className="spacer">|</div>
        <Link to="/privacy">Privacy Policy</Link>
        <div className="spacer">|</div>
        <Link to="/cookies">Cookie Policy</Link>
        <div
          style={{ maxWidth: 500, margin: "auto" }}
          className="has-text-grey is-size-7"
        >
          All artwork, screenshots, characters or other recognizable features of
          the intellectual property relating to these trademarks are likewise
          the intellectual property of Nexon Corporation
        </div>
      </div>
    </footer>
  </div>
);

export default Layout;
